import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { coverEditorMessages } from '../coverEditorMessages';
import type { CoverSaveState } from '../doc/useCoverAutosave';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

const MESSAGES = {
  saved: coverEditorMessages.saveSaved,
  dirty: coverEditorMessages.saveDirty,
  saving: coverEditorMessages.saveSaving,
  failed: coverEditorMessages.saveFailed,
  invalid: coverEditorMessages.saveInvalid,
} as const;

interface SaveStateProps {
  state: CoverSaveState;
  /** The number of the open version in the strip. */
  version: number;
  readOnly: boolean;
}

/** The save state of the top bar (design cover-editor b1: "Saved · version 4"). It is a live region. */
const SaveStateComponent: React.FC<SaveStateProps> = ({ state, version, readOnly }) => {
  const intl = useIntl();
  return (
    <span
      className={clsx(
        styles.saved,
        state !== 'saved' && styles.savedDirty,
        (state === 'failed' || state === 'invalid') && styles.savedFailed
      )}
      role="status"
    >
      <i />
      {readOnly
        ? intl.formatMessage(coverEditorMessages.saveReadOnly)
        : intl.formatMessage(MESSAGES[state], { version })}
    </span>
  );
};

export const SaveState = TypedMemo(SaveStateComponent);
